import React, { Component } from "react";
import { Col, Card, CardBody, Media } from "reactstrap";
import { api_route } from "../../Api-config/config";

class MiniWidgets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "Dashboard", link: "#" },
      ],
      reports: [
        {
          icon: "ri-stack-line",
          title: "Total Clients",
          value: "",
          rate: "2.4%",
          desc: "From previous period",
        },
        {
          icon: "ri-store-2-line",
          title: "Total Transactions Till Date",
          value: "",
          rate: "2.4%",
          desc: "From previous period",
        },
        {
          icon: "ri-briefcase-4-line",
          title: "Total Turnover This Month",
          value: "",
          rate: "2.4%",
          desc: "From previous period",
        },
      ],
    };
  }

  render() {
    if (this.props.tableData.length === 0) {
      return (
        <React.Fragment>
          <Col key={1} md={6}>
            <Card>
              <CardBody>
                <Media>
                  <Media body className="overflow-hidden">
                    <p className="text-truncate font-size-14 mb-2">
                      Total Clients
                    </p>
                    <h4 className="mb-0">{"0"}</h4>
                  </Media>
                  <div className="text-primary">
                    <i className={"ri-briefcase-4-line font-size-24"}></i>
                  </div>
                </Media>
              </CardBody>

              <CardBody className="border-top py-3">
                <div className="text-truncate">
                  <span className="badge badge-soft-success font-size-11 mr-1">
                    <i className="mdi mdi-menu-up"> </i>
                  </span>
                  <span className="text-muted ml-2"></span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Col key={1} md={6}>
            <Card>
              <CardBody>
                <Media>
                  <Media body className="overflow-hidden">
                    <p className="text-truncate font-size-14 mb-2">
                      Number of Transactions This Month
                    </p>
                    <h4 className="mb-0">{this.props.tableData[0].tottratt}</h4>
                  </Media>
                  <div className="text-primary"></div>
                </Media>
              </CardBody>

              <CardBody className="border-top py-3">
                <div className="text-truncate">
                  <span className="badge badge-soft-success font-size-11 mr-1">
                    <i className="mdi mdi-menu-up"> </i>
                  </span>
                  <span className="text-muted ml-2"></span>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col key={1} md={6}>
            <Card>
              <CardBody>
                <Media>
                  <Media body className="overflow-hidden">
                    <p className="text-truncate font-size-14 mb-2">
                      Total Number of Transactions
                    </p>
                    <h4 className="mb-0">{this.props.tableData[0].tottra}</h4>
                  </Media>
                  <div className="text-primary"></div>
                </Media>
              </CardBody>

              <CardBody className="border-top py-3">
                <div className="text-truncate">
                  <span className="badge badge-soft-success font-size-11 mr-1">
                    <i className="mdi mdi-menu-up"> </i>
                  </span>
                  <span className="text-muted ml-2"></span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </React.Fragment>
      );
    }
  }
}

export default MiniWidgets;
